import React from 'react';
import './welcome-back-modal.scss';
import { Modal } from 'react-bootstrap';

function WelcomeBackModal({ show, setShow }) {
    return (
        <Modal show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Вітання</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {`Вітаємо із поверненням, ${localStorage.getItem('operator')}`}
            </Modal.Body>
        </Modal>
    );
}

export default WelcomeBackModal;
